/**
 * Derive a polling interval for the delivery-metrics dashboard
 * from the selected relative time window.
 *
 * Narrow windows show fast-moving data and deserve a tighter refresh;
 * wide windows aggregate hours of history where a 2-minute lag is
 * imperceptible (and polling faster just burns backend cycles).
 *
 *   window <= 5 min   -> 15s
 *   window <= 15 min  -> 30s
 *   window <= 60 min  -> 60s
 *   wider (6h / 24h)  -> 120s
 *
 * The 15s floor also covers degenerate inputs (0 / negative) so the
 * dashboard can never poll-spin the API.
 */
export const MIN_POLL_INTERVAL_MS = 15_000;
export const MAX_POLL_INTERVAL_MS = 120_000;

export function pollIntervalFor(timeWindowMinutes: number): number {
  if (timeWindowMinutes <= 5) return MIN_POLL_INTERVAL_MS;
  if (timeWindowMinutes <= 15) return 30_000;
  if (timeWindowMinutes <= 60) return 60_000;
  return MAX_POLL_INTERVAL_MS;
}
